import PageBuilderEmbedPreview from "./PageBuilderEmbedPreview";

export default PageBuilderEmbedPreview;